@if (initialized) {
    <p-blockUI [blocked]="busy"/>
    <div class="grid p-fluid">
        <div class="col-12">
            <mvs-widget class="shadow-1 block"
                    *ngIf="basicDataWidget"
                    [widgetData]="basicDataWidget"
                    [widgetToolbarButtons]="widgetToolbarButtons"
                    (onToolbarButtonClick)="handleToolbarButtonClick($event)"
            ></mvs-widget>
        </div>

        @if (dto) {
            <div class="col-12">
                <div class="card p-3 shadow-1 border-round surface-0">
                    <div class="flex flex-wrap gap-4 align-items-stretch">
                        <div class="flex flex-column gap-1">
                            <span class="text-600 font-medium text-sm">Datensätze gesamt</span>
                            <span class="text-2xl font-medium">{{ dto.recordCount ?? 0 }}</span>
                        </div>
                        @if (dto.recordsCreated != null) {
                            <p-divider layout="vertical"/>
                            <div class="flex flex-column gap-1">
                                <span class="text-600 font-medium text-sm">
                                    <i class="fa-regular fa-plus text-green-500 mr-1"></i>Angelegt
                                </span>
                                <span class="text-2xl font-medium text-green-500">{{ dto.recordsCreated }}</span>
                            </div>
                        }
                        @if (dto.recordsUpdated != null) {
                            <p-divider layout="vertical"/>
                            <div class="flex flex-column gap-1">
                                <span class="text-600 font-medium text-sm">
                                    <i class="fa-regular fa-pen-to-square text-blue-500 mr-1"></i>Aktualisiert
                                </span>
                                <span class="text-2xl font-medium text-blue-500">{{ dto.recordsUpdated }}</span>
                            </div>
                        }
                        @if (dto.recordsSkipped != null) {
                            <p-divider layout="vertical"/>
                            <div class="flex flex-column gap-1">
                                <span class="text-600 font-medium text-sm">
                                    <i class="fa-regular fa-forward text-color-secondary mr-1"></i>Übersprungen
                                </span>
                                <span class="text-2xl font-medium text-600">{{ dto.recordsSkipped }}</span>
                            </div>
                        }
                        @if (dto.recordsErrors != null) {
                            <p-divider layout="vertical"/>
                            <div class="flex flex-column gap-1">
                                <span class="text-600 font-medium text-sm">
                                    <i class="fa-regular fa-circle-exclamation text-red-500 mr-1"></i>Fehler
                                </span>
                                <span class="text-2xl font-medium text-red-500">{{ dto.recordsErrors }}</span>
                            </div>
                        }
                    </div>
                </div>
            </div>
        }

<!--        <div class="col-12 sticky z-1" style="top:57px" *ngIf="statusEntries">-->

<!--            <div class="flex gap-3 justify-content-between align-items-center surface-0 p-3 shadow-1">-->
<!--                <div class="flex gap-3 overflow-auto align-items-center">-->
<!--                    <div class="flex gap-3 overflow-hidden">-->

<!--                        <p-chip (click)="onStatusClick()"-->
<!--                                class="w-max cursor-pointer p-1 border-round-xl {{selectedStatus == null ? 'bg-primary-100 text-primary border-1 border-primary-500' : 'surface-200 border-1 border-300'}}">-->
<!--                            <span class="mx-2 w-max"> All Imports</span>-->
<!--&lt;!&ndash;                            [severity]="selectedStatus == null ? 'info' : 'primary'"&ndash;&gt;-->
<!--                            <p-badge [value]="totalCount" class="mx-1"/>-->
<!--                        </p-chip>-->

<!--                        @for (status of statusEntries; track status.key) {-->

<!--                            <p-chip-->
<!--                                    styleClass="w-max cursor-pointer p-1 border-round-xl {{selectedStatus == status.key ? 'bg-primary-100 text-primary border-1 border-primary-500' : 'surface-200 border-1 border-300'}}"-->
<!--                                    (click)="onStatusClick(status.key)">-->
<!--                                <span class="mx-2"> {{ status.label }}</span>-->
<!--&lt;!&ndash;                                selectedStatus == status.key ? 'info' :&ndash;&gt;-->
<!--                                <p-badge [value]="status?.count" class="mx-1"-->
<!--                                         [severity]="status.key == EiImportRecordStatusInternal.ERROR ? 'danger' : 'primary'"/>-->
<!--                            </p-chip>-->

<!--                        }-->
<!--                    </div>-->
<!--                </div>-->
<!--            </div>-->

<!--        </div>-->

        <div class="col-12 p-0">
            <mvs-multi-select-toolbar-component [statusEntries]="statusEntries" [selectedStatus]="[selectedStatus]" [totalCount]="totalCount" (statusClick)="onStatusClick($event)"></mvs-multi-select-toolbar-component>
        </div>

        <div class="col-12">
            <mvs-widget class="shadow-1 block"
                    *ngIf="eiImportRecordWidget"
                    [widgetData]="eiImportRecordWidget"
                    (onObjectSelect)="handleObjectSelect($event)"
            ></mvs-widget>
        </div>

    </div>
}